import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { WarehouseTransfer } from 'src/app/assabil-sales/models/entities/warehouse-transfer';
import { WarehouseService } from 'src/app/assabil-sales/services/warehouse-service';
import { Field } from 'src/app/tools/models/dtos/field';
import { WarehouseTransferPipe } from 'src/app/assabil-sales/pipes/warehouse-transfer-pipe';
import { WarehouseTransferRequestPipe } from 'src/app/assabil-sales/pipes/warehouse-transfer-request-pipe';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { RoleLovComponent } from 'src/app/assabil-admin/components/master-data/role/role-lov/role-lov.component';
import { WarehouseTransferTypeModal } from '../warehouse-transfer-type-modal/warehouse-transfer-type-modal.component';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { WarehouseTransferRequest } from 'src/app/assabil-sales/models/entities/warehouse-transfer-request';
import { WarehouseTransferType } from 'src/app/assabil-sales/enums/warehouse-transfer-type';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'warehouse-transfer-list',
  templateUrl: './warehouse-transfer-list.component.html',
  styleUrls: ['./warehouse-transfer-list.component.scss']
})


export class WarehouseTransferListComponent extends BasePage2<WarehouseTransfer> {

  WarehouseTransfers    : WarehouseTransfer[] = [];
  warehouseTransferCode : string;
  roleCode              : string;
  progressLevel         : any;
  startDate             : Date = new Date();
  endDate               : Date;

  tt_regular            : boolean = true;
  tt_presales           : boolean = true;
  tt_regular_mobile     : boolean = true;
  tt_purchase           : boolean = true;
  tt_direct             : boolean = true;
  tt_sr_to_sr           : boolean = true;
  tt_handover           : boolean = true;
  includeCanceled       : boolean = false;


  warehouseTransferRequestFields  : any[];
  warehouseTransferLineFields     : any[];   
  sdeliveryNoteFields             : any[];    
       

  constructor(   
    protected dialog                : MatDialog,
    protected toastr                : ToastrService,
    protected router                : Router,
    protected masterDataService     : MasterDataService,
    protected warehouseService      : WarehouseService,
    protected baseService           : BaseService,
    protected leanUtilsService      : LeanUtilsService,
    protected location              : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = "warehouseTransfer";
  }


//----------------------------------------------------------------------
ngAfterViewInit(): void {
  super.ngAfterViewInit();
    this.setChildFields();
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
setChildFields(){
      this.baseService.fieldsGet('warehouseTransferRequest').then(result => {
            this.warehouseTransferRequestFields = result.listFields;
            this.warehouseTransferRequestFields.forEach( f => {
                this.enrichField_Wtr(f)
            })
      }); 
      this.baseService.fieldsGet('warehouseTransferLine').then(result => {
        this.warehouseTransferLineFields = result.listFields;
      });
      this.baseService.fieldsGet('sdeliveryNote').then(result => {
        this.sdeliveryNoteFields = result.listFields;
      });

      /*
            this.baseService.fieldsGet('warehouseTransferRequestFields').then(result => {
            this.childFields = result.listFields;
            this.readOnly    = result.readOnly;

            this.childFields.forEach(field => {
                if (field.prop == 'term.termCode') {
                  field.modal = TermLovComponent;
                }
            })

      }) 
    */
  
  }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
getRows(): WarehouseTransfer[] {
      return this.WarehouseTransfers;
  }
//----------------------------------------------------------------------



//-------------------------------------------------------------------------------
newWarehouseTransfer() {
  let title  : string  = "Type de Demande de Transfert";

  let dialogRef = this.dialog.open(WarehouseTransferTypeModal, {autoFocus:false, hasBackdrop: false, data : {title : title}});
  dialogRef.afterClosed().subscribe(returnWt => {
        if (returnWt != null) {
          this.newWarehouseTransfer2(returnWt);
        }
  });
}
//-------------------------------------------------------------------------------


//-------------------------------------------------------------------------------
newWarehouseTransfer2(returnWt : boolean){
  let dialogRef = this.dialog.open(RoleLovComponent, {autoFocus : false, hasBackdrop : false});
  dialogRef.afterClosed().subscribe(role => {
      if (role) {
        this.newWarehouseTransfer3(role, returnWt);
      }
  });
  
}
//--------------------------------------------------------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------------------------------------------------------
newWarehouseTransfer3(requestedForRole : Role, returnWt : boolean){
  let warehouseTransfer : WarehouseTransfer = new WarehouseTransfer();

  warehouseTransfer.requestedForRole= requestedForRole;
  warehouseTransfer.confirmedByRole = new Role();
  warehouseTransfer.progressLevel   = 0;
  warehouseTransfer.returnWt        = returnWt;
  warehouseTransfer.transferType     = WarehouseTransferType.tt_regular

  warehouseTransfer.inserted        = true;
  warehouseTransfer.edit            = true;

  this.masterDataService.productsStockGet(requestedForRole.warehouse.warehouseCode).then(products => {
    for (let product of products) {
      let warehouseTransferRequest : WarehouseTransferRequest = new WarehouseTransferRequest();
      warehouseTransferRequest.inserted = true;
      warehouseTransferRequest.product = product;
      warehouseTransferRequest.availableQuantity = product.availableQuantity;
      warehouseTransfer.warehouseTransferRequests.push(warehouseTransferRequest);
    }
    this.selectedRow = warehouseTransfer;
})
}
//--------------------------------------------------------------------------------------------------------------------------------------




//----------------------------------------------------------------------
  loadData() {    
    let progressLevelId : number = null;
    if (this.progressLevel) progressLevelId = this.progressLevel.id;
    
    this.warehouseService.warehouseTransfersGet(this.warehouseTransferCode, this.roleCode, progressLevelId, 
      this.startDate, this.endDate, 
      this.tt_regular, this.tt_presales, this.tt_regular_mobile,  this.tt_purchase, this.tt_direct, this.tt_sr_to_sr, this.tt_handover, 
      this.includeCanceled).then(result => {
      this.WarehouseTransfers = result;
    })
  }
// ---------------------------------------------------
  
//----------------------------------------------------------------------
selectRow(warehouseTransfer : WarehouseTransfer){
  let withSdeliveries           : boolean =   ( (warehouseTransfer.progressLevel == 20) || (warehouseTransfer.progressLevel == 30) ); 
  let withWarehouseTransferLine : boolean = withSdeliveries;

  this.warehouseService.warehouseTransferGet(warehouseTransfer.warehouseTransferCode, withSdeliveries, withWarehouseTransferLine).then(result => {

    if (result.progressLevel == 10) {
      result.warehouseTransferRequests.forEach(wtr => {
        
        wtr.movedQuantity1 = 0;
        wtr.movedQuantity2 = 0;
        wtr.movedQuantity3 = 0;
        wtr.movedQuantity4 = 0;

        if (wtr.confirmedQuantity)                  wtr.movedQuantity1 = wtr.confirmedQuantity;
        if (wtr.confirmedReturnedQuantity)          wtr.movedQuantity2 = wtr.confirmedReturnedQuantity;
        if (wtr.confirmedReturnedDamagedQuantity1)  wtr.movedQuantity3 = wtr.confirmedReturnedDamagedQuantity1;
        if (wtr.confirmedReturnedDamagedQuantity2)  wtr.movedQuantity4 = wtr.confirmedReturnedDamagedQuantity2;
      });
    }

    this.selectedRow = result;
  })
}


//----------------------------------------------------------------------
warehouseTransferPipe             : WarehouseTransferPipe = new WarehouseTransferPipe();
//----------------------------------------------------------------------
enrichField(field : Field){
  if (field.prop == 'progressLevel') {    
      field.pipe = this.warehouseTransferPipe;
  }

  if (field.prop == 'transferType') {    
    field.pipe = this.warehouseTransferPipe;
  }

  if (field.prop == 'requestedForRole') {    
    field.modal = RoleLovComponent;
    field.subProp = 'name';
  }
}

warehouseTransferRequestPipe : WarehouseTransferRequestPipe = new WarehouseTransferRequestPipe();
enrichField_Wtr(field : Field){
  if (field.prop == 'quantities') {    
      field.pipe = this.warehouseTransferRequestPipe;
  }
}
//----------------------------------------------------------------------

}

